import { create } from "zustand";

import {
  nonPersistantUiSlice,
  NonPersistantUiStoreInterface,
} from "./ui-event";
import { WatchListInterface, WatchListSlice } from "./watchlist";
import { selectTicketsSlice, SelectTicketInterface } from "./ticket";
import {
  customerAndUserInterface,
  customerAndUserSlice,
} from "./customer/customerAndUserStore";
import {
  FeatureFlagInterface,
  featureFlagSlice,
  MspFlagsInterface,
  mspFlagsSlice,
} from "./feature-flag";

export const useNonPersistantMainStore = create<
  NonPersistantUiStoreInterface &
    WatchListInterface &
    FeatureFlagInterface &
    SelectTicketInterface &
    customerAndUserInterface &
    MspFlagsInterface
>()((...a) => ({
  ...nonPersistantUiSlice(...a),
  ...WatchListSlice(...a),
  ...featureFlagSlice(...a),
  ...selectTicketsSlice(...a),
  ...customerAndUserSlice(...a),
  ...mspFlagsSlice(...a),
}));
